import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import PowerAdd from '@/components/System/Power/PowerAdd';
import NoData from '@/components/NoData/NoData';
import PowerMaintain from '@/components/System/Power/PowerMaintain';
import { valsubstr32addbr } from '@/utils/index';
import delDialog from '@/components/System/DelDialog';
import { getUserId } from '@/utils/auth';
export default {
  components: {
    SearchForm: SearchForm,
    PowerAdd: PowerAdd,
    PowerMaintain: PowerMaintain,
    NoData: NoData,
    delDialog: delDialog
  },
  data: function data() {
    return {
      multipleSelection: null,
      delChecked: false,
      // 删除权限
      searchFormData: [{
        title: '系统名称',
        key: 'sysName',
        placeholder: '请选择系统名称',
        type: 'selectsystem',
        selectData: [],
        selectedArr: [],
        multiple: false
      }, {
        title: '权限名称',
        key: 'sysName',
        placeholder: '请输入权限名称',
        type: 'input',
        value: null
      }],
      tableData: [],
      menulist: [],
      portlist: [],
      mobilemenulist: [],
      btnType: 'add,search,reset',
      showPowerMaintain: false,
      // 角色与权限关联
      showPowerPower: false,
      // 查看权限
      ifAddEdit: false,
      // true 编辑  false 新增
      showRoleEdit: false,
      // 显示角色编辑弹出框
      showRoleUserEdit: false,
      // 指定用户
      selectpermission: null,
      selectsystem: null,
      editPermission: null,
      isfiltrate: false,
      filtratedata: {
        pageNum: 1,
        pageSize: 10,
        permissionName: '',
        systemId: ''
      },
      dellist: [],
      formRole: {
        sysName: [],
        roleNum: null,
        roleName: [],
        type: null,
        desc: null,
        status: null
      },
      currentPage: 1,
      totalrecord: 0,
      showpop: false,
      // 是否显示编辑删除
      ifShowDelDialog: false,
      loading: false,
      tableheight: 512,
      isIndeterminate: false,
      pageshow: true
    };
  },
  created: function created() {
    this.getsystemlist();
    this.getpermissiontype();
    this.getpermissionlist();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    getpermissionlist: function getpermissionlist() {
      var _this = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/permission/list',
        data: this.filtratedata
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.tableData = res.result.records;
          _this.totalrecord = res.result.total;
        }
      });
    },
    getsystemlist: function getsystemlist() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.searchFormData[0].selectData = res.result.records;
        }
      });
    },
    getpermissiontype: function getpermissiontype() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/permission'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.searchFormData[1].selectData = res.result.permissionType;
        }
      });
    },
    getportresources: function getportresources() {
      var _this4 = this;
      this.$API.getRequest({
        url: "/platform/permission/resource/".concat(this.selectpermission.permissionId),
        data: {
          permissionId: this.selectpermission.permissionId,
          systemId: this.selectpermission.systemId,
          resourceType: 'INTERFACE'
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.portlist = res.result;
          //  console.log("res.result",res.result);
        }
      });
    },
    getmenuresources: function getmenuresources() {
      var _this5 = this;
      this.$API.getRequest({
        url: "/platform/permission/resource/".concat(this.selectpermission.permissionId),
        data: {
          permissionId: this.selectpermission.permissionId,
          systemId: this.selectpermission.systemId,
          resourceType: 'RESOURCE'
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.menulist = res.result;
          _this5.setisIndeterminate(_this5.menulist);
        }
      });
    },
    getmobilemenuresources: function getmobilemenuresources() {
      var _this6 = this;
      this.$API.getRequest({
        url: "/platform/permission/resource/".concat(this.selectpermission.permissionId),
        data: {
          permissionId: this.selectpermission.permissionId,
          systemId: this.selectpermission.systemId,
          resourceType: 'MOBILE'
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this6.mobilemenulist = res.result;
          _this6.setisIndeterminate(_this6.mobilemenulist);
        }
      });
    },
    setisIndeterminate: function setisIndeterminate(menulist) {
      var _this7 = this;
      // eslint-disable-next-line array-callback-return
      menulist.filter(function (item) {
        item.Indeterminate = false;
        if (item.children.length > 0) {
          _this7.setisIndeterminate(item.children);
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      // let checkedCount = val.length;
      // this.delChecked = checkedCount === this.tableData.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      this.multipleSelection = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.filtratedata.pageNum = val;
      this.getpermissionlist();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.filtratedata.pageSize = val;
      // this.filtratedata.pageNum = 1;
      this.getpermissionlist();
    },
    searchForm: function searchForm(obj) {
      this.isfiltrate = true;

      // let systemlist =  obj[0].value;
      // this.filtratedata.systemId = systemlist[systemlist.length - 1];
      this.filtratedata.systemId = obj[0].selectedArr;
      this.filtratedata.permissionName = obj[1].value;
      this.filtratedata.pageNum = 1;
      this.getpermissionlist();
    },
    resetForm: function resetForm() {
      this.searchFormData[0].selectedArr = [];
      this.searchFormData[1].value = '';
      this.filtratedata.systemId = '';
      this.filtratedata.permissionName = '';
      this.filtratedata.pageNum = 1;
      this.getpermissionlist();
    },
    addTable: function addTable() {
      // this.editRoleDialog(obj, false)
      this.ifAddEdit = false;
      this.powerAddClose(true);
      // if(this.$refs.poweradddefult){
      //   this.$refs.poweradddefult.setdefult();
      // }
    },
    delPowerDialog: function delPowerDialog() {
      var _this8 = this;
      this.$API.delRequest({
        url: '/platform/permission/',
        data: this.dellist
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this8.$message({
            message: '删除权限成功',
            type: 'success'
          });
          _this8.getpermissionlist();
        }
      });
    },
    confirmdel: function confirmdel(obj, bool) {
      this.showpop = false;
      if (bool) {
        this.$refs["power-".concat(obj.row.id)].doClose();
        this.dellist = [obj.row.permissionId];
        var page = Math.ceil(this.totalrecord / this.filtratedata.pageSize); // 最大页数
        if (this.filtratedata.pageNum === page) {
          if (this.totalrecord % this.filtratedata.pageSize === 1) {
            this.filtratedata.pageNum > 1 ? this.filtratedata.pageNum-- : this.filtratedata.pageNum = 1;
          } else if (this.totalrecord % this.filtratedata.pageSize === this.dellist.length) {
            this.filtratedata.pageNum > 1 ? this.filtratedata.pageNum-- : this.filtratedata.pageNum = 1;
          }
        }
        this.delPowerDialog();
      }
    },
    seePowerDialog: function seePowerDialog(item) {
      this.selectpermission = item.row;
      this.showpop = false;
      this.$refs["power-".concat(item.row.id)].doClose();
      this.getmenuresources();
      this.getportresources();
      this.getmobilemenuresources();
      this.powerMaintainClose(true);
    },
    editRoleDialog: function editRoleDialog(item, bool) {
      this.ifAddEdit = bool;
      this.showpop = false;
      this.$refs["power-".concat(item.row.id)].doClose();
      this.editPermission = item.row;
      // this.selectsystem = item.row;
      this.selectsystem = JSON.parse(JSON.stringify(item.row));
      this.powerAddClose(true);
    },
    editRoleUserDialog: function editRoleUserDialog() {
      this.showRoleUserEdit = true;
    },
    submitRoleForm: function submitRoleForm(formName) {
      this.$refs[formName].validate(function (valid) {
        if (!valid) {
          return false;
        }
      });
    },
    powerAddClose: function powerAddClose(bool) {
      this.showRoleEdit = bool;
    },
    powerAddSubmit: function powerAddSubmit(obj) {
      this.powerAddClose(false);
      if (obj.bool) {
        // 点击提交
        if (this.ifAddEdit) {
          obj.formData.id = this.editPermission.id;
          this.powerEditFun(obj);
        } else {
          this.powerAddFun(obj);
        }
      }
    },
    powerAddFun: function powerAddFun(obj) {
      var _this9 = this;
      // sonar 复杂度修改  返回后数据处理移出
      this.$API.postRequest({
        url: '/platform/permission/',
        data: obj.formData
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this9.$message({
            message: '添加权限成功',
            type: 'success'
          });
          _this9.pageshow = false;
          _this9.filtratedata.pageNum = _this9.totalrecord % _this9.filtratedata.pageSize === 0 ? Math.ceil(_this9.totalrecord / _this9.filtratedata.pageSize) + 1 : Math.ceil(_this9.totalrecord / _this9.filtratedata.pageSize);
          _this9.getpermissionlist();
          _this9.$nextTick(function () {
            _this9.pageshow = true;
          });
        }
      });
    },
    powerEditFun: function powerEditFun(obj) {
      var _this10 = this;
      // sonar 复杂度修改  返回后数据处理移出
      this.$API.putRequest({
        url: '/platform/permission/',
        data: obj.formData
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this10.$message({
            message: '修改权限成功',
            type: 'success'
          });
          _this10.getpermissionlist();
        }
      });
    },
    powerMaintainClose: function powerMaintainClose(bool) {
      this.showPowerMaintain = bool;
    },
    powerMaintainSubmit: function powerMaintainSubmit(obj) {
      var _this11 = this;
      this.powerMaintainClose(false);
      if (obj.bool) {
        this.$API.postRequest({
          url: "/platform/permission/resourceRef/".concat(this.selectpermission.permissionId),
          data: obj.selectlist
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this11.$message({
              message: '权限资源对应关系维护成功',
              type: 'success'
            });
            _this11.getMenuData();
          }
        });
      }
    },
    showdeldialog: function showdeldialog() {
      var _this12 = this;
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        var h = this.$createElement;
        this.$confirm(h('div', null, [h('p', {
          style: 'font-weight: 500; color: #333333; marginBottom: 6px; fontSize: 16px;'
        }, '确定要删除所选权限吗？ '), h('p', {
          style: 'font-weight: 400; color: #666666; fontSize: 14px;'
        }, '删除权限后无法恢复，是否要删除权限')]), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'custom-confirm-dialog',
          type: 'warning'
        }).then(function () {
          _this12.delpermission();
        }).catch(function () {
          return false;
        });
      } else {
        this.$message({
          message: '请选择删除项',
          type: 'warning'
        });
      }
    },
    delpermission: function delpermission() {
      var _this13 = this;
      this.ifShowDelDialog = false;
      this.dellist = [];
      // eslint-disable-next-line array-callback-return
      this.multipleSelection.filter(function (item) {
        _this13.dellist.push(item.permissionId);
      });
      if (this.filtratedata.pageNum === Math.ceil(this.totalrecord / this.filtratedata.pageSize) && (this.totalrecord % this.filtratedata.pageSize === this.dellist.length || this.totalrecord % this.filtratedata.pageSize === 0)) {
        this.filtratedata.pageNum > 1 ? this.filtratedata.pageNum-- : this.filtratedata.pageNum = 1;
      }
      this.delPowerDialog();
    },
    // 全选
    // selectAll(checked){
    //   if(checked){
    //    this.tableData.forEach((ele)=>{
    //        this.$refs.multipleTable.toggleRowSelection(ele,true)
    //    })
    //   }else{
    //     this.$refs.multipleTable.clearSelection()
    //   }
    //   this.isIndeterminate = false;
    // },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    getMenuData: function getMenuData() {
      var _this14 = this;
      this.$API.getMenuInfo({
        userId: getUserId()
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this14.$store.dispatch('settings/changeSetting', {
            key: 'menuArr',
            value: res.result.resourceList
          });
          _this14.$store.dispatch('settings/changeSetting', {
            key: 'roleTypeArr',
            value: res.result.roleList
          });
          _this14.$store.dispatch('settings/changeSetting', {
            key: 'userinfo',
            value: res.result.user
          });
        }
      }).catch(function () {});
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};